import React from "react";
import "./AboutUs.css";
//-----------------------------------------
import eshopPhoto from "../images/eshopPhoto.png";
//-----------------------------------------

function AboutUs() {
  return (
    <div className="aboutUs_container">
      <div className="aboutUs_photo_div">
        <img className="aboutUs_photo" src={eshopPhoto} alt="eshopPhoto Logo" />
        <div className="email_address_div">
          <p className="email_address">
            paranaeshopservices
            <br />
            @gmail.com
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
